import React from 'react';
import PropTypes from 'prop-types';

import {Button, Modal, Header } from 'semantic-ui-react';

const RemovePolicyModal = ({open, onCancel, onYes, policy}) => {
    return (
<Modal size="tiny" open={open}>
<Header icon="trash" content="Remove Policy" />
<Modal.Content>
    <p>Are you sure you want to remove policy {policy.policyNumber} from your list?</p>
    <p>This will not cancel the policy. If you wish to cancel the policy, please contact your agent.</p>
</Modal.Content>
<Modal.Actions>
    <Button positive content="No" onClick={onCancel} />
    <Button negative content="Yes" onClick={onYes} />
</Modal.Actions>
</Modal>
    );
};

RemovePolicyModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onYes: PropTypes.func.isRequired,
    policy: PropTypes.object.isRequired,
};

export default RemovePolicyModal;